module.exports = __webpack_public_path__ + "img/MHB.f96172b1.png";